// extracted by mini-css-extract-plugin
export default {"AskAQuestionContainer":"AskAQuestion_AskAQuestionContainer__0U01G","askAQuestionBtn":"AskAQuestion_askAQuestionBtn__4unEj"};